import Home from "./Home/Home"; 
// import Projects from "./Projects/Projects";
// import About from "./About/About";
import Allroutes from "./Allroutes";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <Allroutes/>
  );
}

export default App;
